module.exports = __webpack_public_path__ + "img/Basket-Ball.efa5cf0.png";